/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const DownloadReport = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 15 19">
      <g>
        <path d="M14,18 L1,18 L1,5 L4.5,5 C4.776,5 5,4.776 5,4.5 L5,1 L14,1 L14,18 Z M4,1.707 L4,4 L1.707,4 L4,1.707 Z M14.5,0 L4.5,0 C4.477,0 4.457,0.01 4.435,0.014 C4.413,0.016 4.396,0.02 4.375,0.025 C4.288,0.048 4.207,0.085 4.146,0.147 L0.147,4.146 C0.086,4.207 0.049,4.287 0.025,4.373 C0.02,4.395 0.016,4.413 0.013,4.436 C0.01,4.457 0,4.477 0,4.5 L0,18.5 C0,18.776 0.224,19 0.5,19 L14.5,19 C14.776,19 15,18.776 15,18.5 L15,0.5 C15,0.224 14.776,0 14.5,0 L14.5,0 Z" />
        <path d="M5.1465 11.9033L7.1455 13.9023C7.1925 13.9493 7.2485 13.9863 7.3085 14.0113 7.3705 14.0373 7.4345 14.0493 7.5005 14.0493 7.5655 14.0493 7.6295 14.0373 7.6915 14.0113 7.7515 13.9863 7.8075 13.9493 7.8545 13.9023L9.8535 11.9033C10.0485 11.7083 10.0485 11.3913 9.8535 11.1963 9.6585 11.0013 9.3415 11.0013 9.1465 11.1963L8.0005 12.3423 8.0005 7.5003C8.0005 7.2233 7.7765 7.0003 7.5005 7.0003 7.2235 7.0003 7.0005 7.2233 7.0005 7.5003L7.0005 12.3423 5.8535 11.1963C5.6585 11.0013 5.3415 11.0013 5.1465 11.1963 4.9515 11.3913 4.9515 11.7083 5.1465 11.9033M4 15.5C4 15.776 4.224 16 4.5 16L10.5 16C10.776 16 11 15.776 11 15.5 11 15.224 10.776 15 10.5 15L4.5 15C4.224 15 4 15.224 4 15.5" />
      </g>
    </BaseSvgIcon>
  )
}

export default DownloadReport
